// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2q4GT","right":"styles_right__1q44L"};